
function Error() {
  return (
    <div className="flex-row-center">
      <h1>Oops it looks like something went wrong ☹️</h1>
    </div>
  )

}

export default Error